import React, {Suspense} from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router';
import App from '../../pages/publisher/apps/App';
import CmpAppConfiguration from '../../pages/publisher/cmp/CmpAppConfiguration';
import CmpAppGroupConfiguration from '../../pages/publisher/cmp/CmpAppGroupConfiguration';
import UnderMaintenance from "../../components/errors/UnderMaintenance";

function Apps(props) {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route path={`${path}/groups/:appGroupId/cmp/configuration`} component={CmpAppGroupConfiguration}/>
        <Route path={`${path}/:appId/cmp/configuration`} component={CmpAppConfiguration}/>
        <Route path={`${path}/:appId/cmp/analytics`} component={UnderMaintenance}/>
        <Route path={`${path}/:appId`} component={App}/>
      </Switch>
    </Suspense>
  )
}

export default Apps
